// Simple constants implementation to replace react-constants
const constants = (arr) => {
  const obj = {};
  arr.forEach(key => {
    obj[key] = key;
  });
  return obj;
};

export const global = constants([
  "LANGUAGE_PACKAGE_SWITCH",
  "GET_JSON_LANGUAGE_PACKAGE"
]);

